<template>
  <div
    class="curriculumDetails"
    :class="{ 'curriculumDetails--plan-builder': isStudyPlanBuilder }"
  >
    <!-- W6/W7：选课强阻断（不可关遮罩、无关闭按钮、无取消） -->
    <el-dialog
      :model-value="showPlanResubmitWall"
      fullscreen
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      align-center
      append-to-body
      class="plan-block-dialog plan-block-dialog--resubmit"
    >
      <div class="plan-block-dialog__body">
        <p class="plan-block-dialog__text">
          因课程规则调整，已选课件已被重置，请重新选课（原有播放进度已保留）。
        </p>
        <el-button type="primary" size="large" @click="acknowledgePlanResubmit">
          去重新选课
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :model-value="showPlanInvalidWall"
      fullscreen
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      align-center
      append-to-body
      class="plan-block-dialog plan-block-dialog--invalid"
    >
      <div class="plan-block-dialog__body">
        <p class="plan-block-dialog__text">
          因课程内容调整，暂时无法重新选课，请联系管理员核对配置。
        </p>
        <el-button
          type="primary"
          size="large"
          @click="leaveCourseListForInvalidPlan"
        >
          返回课程列表
        </el-button>
      </div>
    </el-dialog>
    <div v-if="isLearningMode" class="media">
      <div class="title">
        {{ viewTitle }}
        <!-- <el-button v-if="currentPlayStatus" @click="onPlayerEnded" size="mini" style="position: absolute;right: 4px;top: 4px;">已学完此课程</el-button> -->
      </div>
      <!-- <div class="title2">（温馨提示：非直播视频学员需要点击暂停键才能断点续播）</div> -->
      <div class="media-player-shell">
        <div class="media-player-inner">
          <video-player
            v-if="playerOptions.sources.length"
            :key="videoPlayerRemountKey"
            class="media-video-player video-player vjs-custom-skin"
            :class="{ aliving: activelives != null, 'alive-done': liveingDone }"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @playing="onPlayerPlaying($event)"
            @pause="onPlayerPause($event)"
            @timeupdate="timeupdate"
            @seeking="onPlayerSeeking"
            @seeked="onPlayerSeeked"
            @ended="onPlayerEnded"
          ></video-player>
          <div
            v-else
            class="media-player-empty"
            role="status"
            aria-live="polite"
          >
            <div class="media-player-empty__glow" aria-hidden="true"></div>
            <div class="media-player-empty__icon-wrap">
              <el-icon class="media-player-empty__icon"><VideoPlay /></el-icon>
            </div>
            <p class="media-player-empty__title">暂无播放内容</p>
            <p class="media-player-empty__hint">
              在右侧「课程目录」中选择课件即可开始学习
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="media-list"
      :class="{ 'media-list--plan-builder': isStudyPlanBuilder }"
    >
      <el-alert
        v-if="isStudyPlanBuilder"
        title="请根据培训课时要求勾选相应课件，提交并完成学习。"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      />
      <div v-if="isStudyPlanBuilder" class="plan-builder-header">
        {{ viewTitle }}
      </div>
      <el-tabs v-model="activeTabsNames">
        <el-tab-pane label="简介" name="first">
          <div class="tab-pane-intro">{{ description }}</div>
        </el-tab-pane>
        <el-tab-pane label="课程目录" name="second">
          <div class="tab-pane-course">
            <div
              v-if="needStudyPlan && planLocked && courseUsesDualQuota"
              class="dual-quota-locked-progress"
            >
              <div class="dual-quota-locked-progress__row">
                <span
                  >必修进度：{{ lockedRequiredEarnedHours }}h /
                  {{ requiredClassHours }}h</span
                >
                <el-progress
                  v-if="requiredClassHours > 0"
                  :percentage="lockedRequiredProgressPercent"
                  :status="lockedRequiredProgressBarStatus"
                  :stroke-width="6"
                  style="margin-top: 6px; max-width: 360px"
                />
              </div>
              <div
                class="dual-quota-locked-progress__row"
                style="margin-top: 10px"
              >
                <span
                  >选修进度：{{ lockedElectiveEarnedHours }}h /
                  {{ electiveTargetClassHours }}h</span
                >
                <el-progress
                  v-if="electiveTargetClassHours > 0"
                  :percentage="lockedElectiveProgressPercent"
                  :status="lockedElectiveProgressBarStatus"
                  :stroke-width="6"
                  style="margin-top: 6px; max-width: 360px"
                />
              </div>
            </div>
            <div
              v-if="lives.length"
              class="course-live-block"
              style="margin-bottom: 20px; background: #f9f9f9; padding: 10px"
            >
              <p style="color: #677897; font-size: 16px; font-weight: bold">
                视频直播
                <span style="color: #f00; font-size: 9px"
                  >(*不计入学习进度)</span
                >
              </p>
              <div
                class="ailve-item"
                v-for="(i, _i) in lives"
                :key="_i"
                @click="viewIives(i, _i)"
                :class="{ active: activelives == _i }"
              >
                {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
                <div class="description">{{ i.aliveDate }}</div>
              </div>
            </div>

            <!-- 状态 B：已锁定 - 分层视图 -->
            <template v-if="needStudyPlan && planLocked">
              <div class="course-locked-scroll">
                <div v-if="planSections.length" class="catalog-plan-section">
                  <div
                    class="video-item"
                    v-for="i in planSections"
                    :key="'plan-' + i.id"
                  >
                    <div class="video-title">{{ i.title }}</div>
                    <div
                      class="video-item-list"
                      v-for="s in i.coursewares"
                      :key="s.id"
                      :class="{
                        active:
                          s.id == activeVideo &&
                          s.sectionId == actvieVideoSections,
                      }"
                      @click="viewViedo(s)"
                    >
                      <div class="video-item-list__top">
                        <div class="main-title">
                          <el-icon class="main-title-icon"
                            ><VideoCameraFilled
                          /></el-icon>
                          <el-tag
                            :type="
                              isCoursewareRequired(s) ? 'danger' : 'success'
                            "
                            :effect="isCoursewareRequired(s) ? 'dark' : 'plain'"
                            size="small"
                            class="main-title-tag"
                          >
                            <span
                              style="
                                display: inline-flex;
                                align-items: center;
                                gap: 3px;
                              "
                            >
                              <el-icon
                                v-if="isCoursewareRequired(s)"
                                style="font-size: 12px"
                                ><Lock
                              /></el-icon>
                              <span>{{
                                isCoursewareRequired(s) ? "必修" : "选修"
                              }}</span>
                            </span>
                          </el-tag>
                          <span class="main-title-text" :title="s.title">{{
                            s.title
                          }}</span>
                          <span
                            v-if="s.author"
                            class="courseware-author"
                            :title="s.author"
                            >{{ s.author }}</span
                          >
                        </div>
                        <div class="video-item-list__meta">
                          <span v-if="s.classHour" class="class-hour-tag"
                            ><span class="class-hour-num">{{
                              s.classHour
                            }}</span>
                            课时</span
                          >
                        </div>
                      </div>
                      <p class="video-item-list__progress">
                        <span class="video-item-list__progress-label"
                          >学习进度：</span
                        >{{ coursewareProgressText(s)
                        }}<span
                          :class="
                            isCoursewareDone(s)
                              ? 'status-done'
                              : 'status-undone'
                          "
                          >{{ isCoursewareDone(s) ? "已完成" : "未完成" }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- 状态 A / 老模式：选课模式下列表单独滚动，底部操作条固定在该 Tab 可视区域底部 -->
            <div
              v-if="!(needStudyPlan && planLocked) && videos.length"
              class="catalog-flat-root"
              :class="{
                'catalog-flat-root--with-footer': needStudyPlan && !planLocked,
              }"
            >
              <div
                class="catalog-flat-scroll"
                :class="{
                  'catalog-flat-scroll--with-sticky':
                    isStudyPlanBuilder && needStudyPlan && !planLocked,
                }"
              >
                <!-- ======= 已选课时 sticky 汇总条（选课态 planLocked=false / planNeedsResubmit 通用）======= -->
                <div
                  v-if="isStudyPlanBuilder && needStudyPlan && !planLocked"
                  class="plan-hours-sticky-bar"
                >
                  <span class="bar-title">已选课时</span>
                  <div class="bar-cards">
                    <!-- 双配额：必修卡 -->
                    <div
                      v-if="courseUsesDualQuota"
                      class="bar-card"
                      :class="
                        remainingRequiredHours > 0
                          ? 'bar-card--warn'
                          : 'bar-card--ok'
                      "
                    >
                      <div class="bar-card__label">必修课时</div>
                      <div class="bar-card__nums">
                        <span class="current">{{ selectedRequiredHours }}</span>
                        <span class="divider">/</span>
                        <span class="target">{{ requiredClassHours }} h</span>
                      </div>
                      <div class="bar-card__track">
                        <div
                          class="bar-card__fill"
                          :class="
                            remainingRequiredHours <= 0
                              ? 'bar-card__fill--ok'
                              : ''
                          "
                          :style="{
                            width:
                              requiredClassHours > 0
                                ? Math.min(
                                    (selectedRequiredHours /
                                      requiredClassHours) *
                                      100,
                                    100
                                  ) + '%'
                                : '0%',
                          }"
                        />
                      </div>
                      <div
                        class="bar-card__status"
                        :class="
                          remainingRequiredHours > 0
                            ? 'bar-card__status--warn'
                            : 'bar-card__status--ok'
                        "
                      >
                        <template v-if="remainingRequiredHours > 0"
                          >未达标</template
                        >
                        <template v-else>已达标</template>
                      </div>
                    </div>

                    <!-- Legacy 或双配额：选修卡 -->
                    <div
                      class="bar-card"
                      :class="
                        remainingElectiveHours > 0
                          ? 'bar-card--warn'
                          : 'bar-card--ok'
                      "
                    >
                      <div class="bar-card__label">
                        <template v-if="!courseUsesDualQuota">
                          <span
                            style="
                              font-size: 10px;
                              background: #ecf5ff;
                              color: #409eff;
                              padding: 1px 5px;
                              border-radius: 3px;
                              margin-right: 4px;
                            "
                          >
                            必修已自动选入
                          </span>
                        </template>
                        选修课时
                      </div>
                      <div class="bar-card__nums">
                        <span class="current">{{ selectedElectiveHours }}</span>
                        <span class="divider">/</span>
                        <span class="target"
                          >{{ electiveTargetClassHours }} h</span
                        >
                      </div>
                      <div class="bar-card__track">
                        <div
                          class="bar-card__fill"
                          :class="
                            remainingElectiveHours <= 0
                              ? 'bar-card__fill--ok'
                              : ''
                          "
                          :style="{
                            width:
                              electiveTargetClassHours > 0
                                ? Math.min(
                                    (selectedElectiveHours /
                                      electiveTargetClassHours) *
                                      100,
                                    100
                                  ) + '%'
                                : '0%',
                          }"
                        />
                      </div>
                      <div
                        class="bar-card__status"
                        :class="
                          remainingElectiveHours > 0
                            ? 'bar-card__status--warn'
                            : 'bar-card__status--ok'
                        "
                      >
                        <template v-if="remainingElectiveHours > 0"
                          >未达标</template
                        >
                        <template v-else>已达标</template>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ======= /sticky 汇总条 ======= -->
                <!-- 双配额选课态：双池拍平 -->
                <div
                  v-if="isStudyPlanBuilder && courseUsesDualQuota"
                  class="study-plan-builder-wrap"
                >
                  <div class="study-plan-pool-block">
                    <div
                      class="study-plan-dashboard__pool study-plan-dashboard__pool--inline"
                    >
                      <div class="study-plan-dashboard__label">必修课</div>
                      <div class="study-plan-dashboard__value">
                        课时：<strong>{{ requiredClassHours }}</strong> h
                        <span class="study-plan-dashboard__sep">|</span>
                        已选：<strong>{{ selectedRequiredHours }}</strong> h
                        <span
                          v-if="remainingRequiredHours > 0"
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--warn"
                          >未达标</span
                        >
                        <span
                          v-else
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--ok"
                          >已达标</span
                        >
                      </div>
                    </div>
                    <div
                      v-if="requiredSelectionImplicit"
                      class="study-plan-pool-auto-hint"
                    >
                      已自动包含全部课件
                    </div>
                    <div
                      v-for="cw in builderRequiredPool"
                      :key="'req-' + cw.id"
                      class="study-plan-pool-row"
                    >
                      <el-checkbox
                        :model-value="studyPlanRowChecked(cw)"
                        :disabled="requiredSelectionImplicit"
                        @change="(val) => toggleStudyPlanCourseware(cw.id, val)"
                        class="study-plan-pool-row__cb"
                      />
                      <div class="study-plan-pool-row__body">
                        <div class="study-plan-pool-row__title">
                          <el-icon class="main-title-icon"
                            ><VideoCameraFilled
                          /></el-icon>
                          <el-tag type="danger" effect="dark" size="small"
                            >必修</el-tag
                          >
                          <span :title="cw.title">{{ cw.title }}</span>
                        </div>
                        <div
                          v-if="cw.author"
                          class="study-plan-pool-row__author"
                          :title="cw.author"
                        >
                          {{ cw.author }}
                        </div>
                        <div class="study-plan-pool-row__meta">
                          <span v-if="cw.classHour" class="class-hour-tag"
                            ><span class="class-hour-num">{{
                              cw.classHour
                            }}</span>
                            课时</span
                          >
                        </div>
                        <div class="study-plan-pool-row__section">
                          所属章节：{{ cw._sectionTitle }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="study-plan-pool-block study-plan-pool-block--elective"
                  >
                    <div
                      class="study-plan-dashboard__pool study-plan-dashboard__pool--inline"
                    >
                      <div class="study-plan-dashboard__label">选修课</div>
                      <div
                        class="study-plan-dashboard__value"
                        :class="
                          remainingElectiveHours > 0
                            ? 'study-plan-dashboard__value--pending'
                            : 'study-plan-dashboard__value--met'
                        "
                      >
                        课时：<strong>{{ electiveTargetClassHours }}</strong> h
                        <span class="study-plan-dashboard__sep">|</span>
                        已选：<strong>{{ selectedElectiveHours }}</strong> h
                        <span
                          v-if="remainingElectiveHours > 0"
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--warn"
                          >未达标</span
                        >
                        <span
                          v-else
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--ok"
                          >已达标</span
                        >
                      </div>
                    </div>
                    <div
                      v-if="electiveSelectionImplicit"
                      class="study-plan-pool-auto-hint"
                    >
                      已自动包含全部课件
                    </div>
                    <div
                      v-for="cw in builderElectivePool"
                      :key="'elec-' + cw.id"
                      class="study-plan-pool-row"
                    >
                      <el-checkbox
                        :model-value="studyPlanRowChecked(cw)"
                        :disabled="electiveSelectionImplicit"
                        @change="(val) => toggleStudyPlanCourseware(cw.id, val)"
                        class="study-plan-pool-row__cb"
                      />
                      <div class="study-plan-pool-row__body">
                        <div class="study-plan-pool-row__title">
                          <el-icon class="main-title-icon"
                            ><VideoCameraFilled
                          /></el-icon>
                          <el-tag type="success" effect="plain" size="small"
                            >选修</el-tag
                          >
                          <span :title="cw.title">{{ cw.title }}</span>
                        </div>
                        <div
                          v-if="cw.author"
                          class="study-plan-pool-row__author"
                          :title="cw.author"
                        >
                          {{ cw.author }}
                        </div>
                        <div class="study-plan-pool-row__meta">
                          <span v-if="cw.classHour" class="class-hour-tag"
                            ><span class="class-hour-num">{{
                              cw.classHour
                            }}</span>
                            课时</span
                          >
                        </div>
                        <div class="study-plan-pool-row__section">
                          所属章节：{{ cw._sectionTitle }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Legacy 选课 / 无选课：章节大纲树 -->
                <template v-else>
                  <div v-if="isStudyPlanBuilder" class="study-plan-dashboard">
                    <div
                      class="study-plan-dashboard__pool study-plan-dashboard__pool--legacy"
                    >
                      <div class="study-plan-dashboard__label">已选课时</div>
                      <div class="study-plan-dashboard__value">
                        必修课时 <strong>{{ requiredClassHours }}</strong> 课时
                        <span class="study-plan-dashboard__sep">|</span>
                        选修课时
                        <strong>{{ electiveTargetClassHours }}</strong> 课时
                        <span class="study-plan-dashboard__sep">|</span>
                        已选选修
                        <strong>{{ selectedElectiveHours }}</strong> 课时
                        <span
                          v-if="remainingHours > 0"
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--warn"
                          >未达标</span
                        >
                        <span
                          v-else
                          class="study-plan-dashboard__hint study-plan-dashboard__hint--ok"
                          >已达标</span
                        >
                      </div>
                    </div>
                  </div>
                  <p class="catalog-section-title">
                    <template v-if="needStudyPlan">
                      视频课件（请选择选修课件后提交）
                    </template>
                    <template v-else>视频课件</template>
                  </p>
                  <div class="video-item" v-for="(i, _i) in videos" :key="_i">
                    <div class="video-title">{{ _i + 1 }}.{{ i.title }}</div>
                    <div
                      class="video-item-list"
                      v-for="(s, _s) in i.coursewares"
                      :key="_s"
                      :class="{
                        active:
                          s.id == activeVideo &&
                          s.sectionId == actvieVideoSections,
                      }"
                      @click="viewViedo(s)"
                    >
                      <div class="video-item-list__top">
                        <el-checkbox
                          v-if="
                            needStudyPlan &&
                            !planLocked &&
                            !courseUsesDualQuota &&
                            !isCoursewareRequired(s)
                          "
                          :model-value="studyPlanRowChecked(s)"
                          @change="
                            (val) => toggleStudyPlanCourseware(s.id, val)
                          "
                          style="flex-shrink: 0; margin-right: 6px"
                        />
                        <div class="main-title">
                          <el-icon class="main-title-icon"
                            ><VideoCameraFilled
                          /></el-icon>
                          <el-tag
                            v-if="needStudyPlan"
                            :type="
                              isCoursewareRequired(s) ? 'danger' : 'success'
                            "
                            :effect="isCoursewareRequired(s) ? 'dark' : 'plain'"
                            size="small"
                            class="main-title-tag"
                          >
                            <span
                              style="
                                display: inline-flex;
                                align-items: center;
                                gap: 3px;
                              "
                            >
                              <el-icon
                                v-if="isCoursewareRequired(s)"
                                style="font-size: 12px"
                                ><Lock
                              /></el-icon>
                              <span>{{
                                isCoursewareRequired(s) ? "必修" : "选修"
                              }}</span>
                            </span>
                          </el-tag>
                          <span class="main-title-text" :title="s.title">{{
                            s.title
                          }}</span>
                          <span
                            v-if="s.author"
                            class="courseware-author"
                            :title="s.author"
                            >{{ s.author }}</span
                          >
                        </div>
                        <div class="video-item-list__meta">
                          <span v-if="s.classHour" class="class-hour-tag"
                            ><span class="class-hour-num">{{
                              s.classHour
                            }}</span>
                            课时</span
                          >
                        </div>
                      </div>
                      <p class="video-item-list__progress">
                        <span class="video-item-list__progress-label"
                          >学习进度：</span
                        >{{ coursewareProgressText(s)
                        }}<span
                          :class="
                            isCoursewareDone(s)
                              ? 'status-done'
                              : 'status-undone'
                          "
                          >{{ isCoursewareDone(s) ? "已完成" : "未完成" }}</span
                        >
                      </p>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="needStudyPlan && !planLocked"
                class="study-plan-footer"
              >
                <div v-if="!courseUsesDualQuota" class="plan-stats">
                  <span>必修 {{ requiredClassHours }} 课时</span>
                  <span class="divider">|</span>
                  <span>已选选修 {{ selectedElectiveHours }} 课时</span>
                  <span class="divider">|</span>
                  <span v-if="remainingHours > 0" style="color: #e6a23c"
                    >未达标</span
                  >
                  <span v-else style="color: #67c23a">已达标</span>
                </div>
                <p class="study-plan-irreversible-hint">
                  提交后将锁定，不可自行修改，请确认您的选择
                </p>
                <el-button
                  type="primary"
                  class="study-plan-footer__submit"
                  :disabled="!canSubmitPlan || studyPlanSubmitLoading"
                  :loading="studyPlanSubmitLoading"
                  @click="submitStudyPlan"
                  >提交</el-button
                >
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="视频直播" name="third" v-if="lives.length">
          <div
            class="ailve-item"
            v-for="(i, _i) in lives"
            :key="_i"
            @click="viewIives(i, _i)"
            :class="{ active: i.living }"
          >
            {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
            <div class="description">{{ i.aliveDate }}</div>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { ElMessageBox } from "element-plus";
import { VideoCameraFilled, Lock, VideoPlay } from "@element-plus/icons-vue";

/** 选课课时达标容差（与 JS 浮点比较、产品防呆一致） */
const STUDY_PLAN_HOUR_EPS = 0.01;

let VideocurrentTime = 0;
export default {
  name: "curriculum",
  components: { VideoCameraFilled, Lock, VideoPlay },
  data() {
    return {
      videoId: "",
      httpsLocation: "https://tecsf.gdcoh.com",
      activePanesNames: [0],
      activeTabsNames: "second",
      viewTitle: "",
      description: "",
      videos: [],
      videoType: "",
      activeVideo: "",
      actvieVideoSections: 0,
      lives: [],
      activelives: "",
      liveingDone: false,
      currentPlayStatus: false,
      currentPlayTimer: 0,
      lastProgressReportValue: 0,
      lastProgressReportTime: 0,
      progressIncrementThreshold: 5,
      progressReportThrottleMs: 30000,
      // 课件完成判定相关：达到该比例后尝试触发一次“完成”上报，由后端统一校验
      coursewareCompleteThreshold: 0.8,
      hasTriedCompleteOnce: false,
      // 课件进度上报节流
      lastCoursewareProgressReportTime: 0,
      coursewareProgressThrottleMs: 10000,
      // 完成状态上报重试机制
      completionRetryCount: 0,
      maxCompletionRetries: 3,
      completionRetryDelayMs: 2000,
      pendingCompletionReport: null, // 待重试的完成状态上报
      initialDoneVideoIds: new Set(),
      lastValidPlaybackTime: 0,
      // 进度模式与选课
      isNewProgressMode: false,
      serverProgress: 0,
      needStudyPlan: false,
      planLocked: false,
      totalClassHours: 0,
      requiredClassHours: 0,
      electiveTargetClassHours: 0,
      selectedElectives: [],
      selectedRequired: [],
      localSelectedElectives: [],
      localSelectedRequired: [],
      seekingBlocked: false,
      seekRestoreTimer: null,
      lastSeekWarningAt: 0,
      tabLockId: "",
      lockStorageKey: "",
      lockHeartbeatTimer: null,
      lockHeartbeatMs: 10000,
      lockExpireMs: 60000,
      hasCourseLock: false,
      lockBlocked: false,
      lockListenerBound: false,
      planNeedsResubmit: false,
      isCourseDataInvalid: false,
      planResubmitOverlayDismissed: false,
      courseUsesDualQuota: false,
      requiredSelectionImplicit: false,
      electiveSelectionImplicit: false,
      studyPlanSubmitLoading: false,
      /** 当前课程已执行过「自动选课件」引导，避免 initData / nextTick 重复触发 */
      autoCoursewareBootstrappedKey: "",
      playerOptions: {
        //播放速度
        playbackRates: [],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频·。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [],
        //你的封面地址
        // poster:
        // "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F1812.img.pp.sohu.com.cn%2Fimages%2Fblog%2F2009%2F11%2F18%2F18%2F8%2F125b6560a6ag214.jpg&refer=http%3A%2F%2F1812.img.pp.sohu.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1624024420&t=606e426a40c26ff068470eabe257afab",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
      },
    };
  },
  computed: {
    /** 双配额必修池：学员勾选的 A 类课件课时之和（与提交的 selectedRequiredCoursewareIds 一致） */
    selectedRequiredHours() {
      if (!this.needStudyPlan || !this.courseUsesDualQuota) return 0;
      let total = 0;
      this.videos.forEach((section) => {
        (section.coursewares || []).forEach((cw) => {
          if (this.localSelectedRequired.includes(cw.id)) {
            total += Number(cw.classHour) || 0;
          }
        });
      });
      return Math.round(total * 10) / 10;
    },
    selectedElectiveHours() {
      if (!this.needStudyPlan) return 0;
      let total = 0;
      this.videos.forEach((section) => {
        (section.coursewares || []).forEach((cw) => {
          if (
            (cw.required === false || cw.isRequired === false) &&
            this.localSelectedElectives.includes(cw.id)
          ) {
            total += cw.classHour || 0;
          }
        });
      });
      return Math.round(total * 10) / 10;
    },
    remainingHours() {
      return Math.max(
        0,
        this.electiveTargetClassHours - this.selectedElectiveHours
      );
    },
    remainingRequiredHours() {
      return Math.max(0, this.requiredClassHours - this.selectedRequiredHours);
    },
    remainingElectiveHours() {
      return Math.max(
        0,
        this.electiveTargetClassHours - this.selectedElectiveHours
      );
    },
    canSubmitPlan() {
      if (!this.needStudyPlan) return false;
      if (this.courseUsesDualQuota) {
        const eps = STUDY_PLAN_HOUR_EPS;
        const reqOk =
          this.requiredSelectionImplicit ||
          this.selectedRequiredHours >= this.requiredClassHours - eps;
        const elecOk =
          this.electiveSelectionImplicit ||
          this.selectedElectiveHours >= this.electiveTargetClassHours - eps;
        return reqOk && elecOk;
      }
      return (
        this.electiveTargetClassHours - this.selectedElectiveHours <= 0.0001
      );
    },
    /** 锁定计划后：必修已获课时（已完成课件） */
    lockedRequiredEarnedHours() {
      if (!this.needStudyPlan || !this.planLocked) return 0;
      const reqIds = this.courseUsesDualQuota
        ? this.selectedRequired || []
        : null;
      let total = 0;
      this.videos.forEach((section) => {
        (section.coursewares || []).forEach((cw) => {
          const inRequiredPool = this.courseUsesDualQuota
            ? reqIds.includes(cw.id)
            : this.isCoursewareRequired(cw);
          if (inRequiredPool && this.isCoursewareDone(cw)) {
            total += Number(cw.classHour) || 0;
          }
        });
      });
      return Math.round(total * 10) / 10;
    },
    /** 锁定计划后：选修已获课时（已选且已完成） */
    lockedElectiveEarnedHours() {
      if (!this.needStudyPlan || !this.planLocked) return 0;
      let total = 0;
      this.videos.forEach((section) => {
        (section.coursewares || []).forEach((cw) => {
          if (
            !this.isCoursewareRequired(cw) &&
            this.selectedElectives.includes(cw.id) &&
            this.isCoursewareDone(cw)
          ) {
            total += Number(cw.classHour) || 0;
          }
        });
      });
      return Math.round(total * 10) / 10;
    },
    lockedRequiredProgressPercent() {
      const t = Number(this.requiredClassHours) || 0;
      if (t <= 0) return 0;
      return Math.min(
        100,
        Math.round((this.lockedRequiredEarnedHours / t) * 100)
      );
    },
    lockedElectiveProgressPercent() {
      const t = Number(this.electiveTargetClassHours) || 0;
      if (t <= 0) return 0;
      return Math.min(
        100,
        Math.round((this.lockedElectiveEarnedHours / t) * 100)
      );
    },
    /** 双配额锁定态：仅当已学课时达标时显示 success（绿勾），与「已选」无关 */
    lockedRequiredProgressBarStatus() {
      if (!this.needStudyPlan || !this.planLocked || !this.courseUsesDualQuota)
        return undefined;
      const t = Number(this.requiredClassHours) || 0;
      if (t <= STUDY_PLAN_HOUR_EPS) return undefined;
      return this.lockedRequiredEarnedHours >= t - STUDY_PLAN_HOUR_EPS
        ? "success"
        : undefined;
    },
    lockedElectiveProgressBarStatus() {
      if (!this.needStudyPlan || !this.planLocked || !this.courseUsesDualQuota)
        return undefined;
      const t = Number(this.electiveTargetClassHours) || 0;
      if (t <= STUDY_PLAN_HOUR_EPS) return undefined;
      return this.lockedElectiveEarnedHours >= t - STUDY_PLAN_HOUR_EPS
        ? "success"
        : undefined;
    },
    planSections() {
      if (!this.needStudyPlan || !this.planLocked) return [];
      if (this.courseUsesDualQuota) {
        const inPlan = (id) =>
          (this.selectedRequired || []).includes(id) ||
          (this.selectedElectives || []).includes(id);
        return this.videos
          .map((section) => ({
            ...section,
            coursewares: (section.coursewares || []).filter((cw) =>
              inPlan(cw.id)
            ),
          }))
          .filter((section) => section.coursewares.length > 0);
      }
      return this.videos
        .map((section) => ({
          ...section,
          coursewares: (section.coursewares || []).filter(
            (cw) =>
              (cw.required !== false && cw.isRequired !== false) ||
              this.selectedElectives.includes(cw.id)
          ),
        }))
        .filter((section) => section.coursewares.length > 0);
    },
    /** 双配额选课态：必修池拍平（含所属章节名） */
    builderRequiredPool() {
      if (!this.isStudyPlanBuilder || !this.courseUsesDualQuota) return [];
      return this.videos.flatMap((sec) =>
        (sec.coursewares || [])
          .filter((cw) => this.isCoursewareRequired(cw))
          .map((cw) => ({
            ...cw,
            _sectionTitle: sec.title,
            _sectionId: sec.id,
          }))
      );
    },
    /** 双配额选课态：选修池拍平（含所属章节名） */
    builderElectivePool() {
      if (!this.isStudyPlanBuilder || !this.courseUsesDualQuota) return [];
      return this.videos.flatMap((sec) =>
        (sec.coursewares || [])
          .filter((cw) => !this.isCoursewareRequired(cw))
          .map((cw) => ({
            ...cw,
            _sectionTitle: sec.title,
            _sectionId: sec.id,
          }))
      );
    },
    /** 切换片源时强制重建播放器，避免 sources 从空数组更新后 Video.js 不加载 */
    videoPlayerRemountKey() {
      const src =
        this.playerOptions.sources &&
        this.playerOptions.sources[0] &&
        this.playerOptions.sources[0].src;
      return [
        this.videoType,
        String(this.activeVideo),
        String(this.activelives),
        src || "",
      ].join("|");
    },
    showPlanResubmitWall() {
      return (
        this.planNeedsResubmit &&
        !this.isCourseDataInvalid &&
        !this.planResubmitOverlayDismissed
      );
    },
    showPlanInvalidWall() {
      return this.planNeedsResubmit && this.isCourseDataInvalid;
    },
    /** 选课配置台：全宽面板、隐藏左侧播放器 */
    isStudyPlanBuilder() {
      return this.needStudyPlan && !this.planLocked;
    },
    /** 沉浸学习：左侧播放器 + 右侧目录 */
    isLearningMode() {
      return !this.isStudyPlanBuilder;
    },
  },
  watch: {
    "$route.query.id"(n, o) {
      if (n !== o) {
        this.planResubmitOverlayDismissed = false;
        this.initData();
      }
    },
  },
  created() {
    this.videoId = this.$route.query && this.$route.query.id;
    this.cleanOtherUsersCache();
    this.initData();
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.seekRestoreTimer) {
      clearTimeout(this.seekRestoreTimer);
      this.seekRestoreTimer = null;
    }
    // 已取消单窗口限制，直接保存进度
    this.flushProgress(true);
  },
  methods: {
    isCoursewareDone(courseware) {
      return !!(
        courseware &&
        (courseware.isDone === true || courseware.done === true)
      );
    },
    isCoursewareRequired(s) {
      return !!(s && s.required !== false && s.isRequired !== false);
    },
    // 清理其他用户的缓存数据，节省localStorage空间
    cleanOtherUsersCache() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      if (!userInfo.userName) return;

      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只保留当前用户的缓存数据
      const currentUserCache = list.filter(
        (el) => el.userName === userInfo.userName
      );

      // 如果数据有变化才更新（避免不必要的写入）
      if (currentUserCache.length !== list.length) {
        this.$storage.setStorage([
          {
            key: "vidoDataList",
            value: currentUserCache,
          },
        ]);
      }
    },
    initializeCourseLock() {
      // 已取消单窗口限制，此方法不再执行任何操作
      // 保留方法定义以避免可能的调用错误
    },
    generateTabLockId() {
      return `${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
    },
    getCourseLockStorageKey() {
      const courseId = this.$route.query && this.$route.query.id;
      return courseId ? `course_tab_lock_${courseId}` : "";
    },
    parseLockPayload(value) {
      if (!value) return null;
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    getCurrentLockPayload() {
      if (!this.lockStorageKey || typeof window === "undefined") return null;
      return this.parseLockPayload(localStorage.getItem(this.lockStorageKey));
    },
    isLockExpired(payload) {
      if (!payload || !payload.timestamp) return true;
      return Date.now() - payload.timestamp > this.lockExpireMs;
    },
    writeLockPayload(payload) {
      if (!this.lockStorageKey || typeof window === "undefined") return;
      localStorage.setItem(this.lockStorageKey, JSON.stringify(payload));
    },
    acquireCourseLock(initial = false) {
      // 已取消单窗口限制，始终返回 true 表示获取成功
      return true;
    },
    startLockHeartbeat() {
      // 已取消单窗口限制，不再启动心跳机制
      // 清理可能存在的旧定时器
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    stopLockHeartbeat() {
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    releaseCourseLock(removeEntry = true) {
      // 已取消单窗口限制，仅清理可能存在的定时器
      this.stopLockHeartbeat();
    },
    handleLockStorageEvent(event) {
      // 已取消单窗口限制，不再处理锁相关事件
    },
    handleLockDenied() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    handleLockLost() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    ensureCourseLockActive() {
      // 已取消单窗口限制，始终返回 true 允许操作
      return true;
    },
    getActiveCourseware() {
      const section = this.videos.find(
        (el) => el.id == this.actvieVideoSections
      );
      if (!section) {
        return null;
      }
      return (
        section.coursewares.find((item) => item.id == this.activeVideo) || null
      );
    },
    getActiveCoursewareDuration() {
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio) {
        return 0;
      }
      return Number(courseware.vedio.timeLength) || 0;
    },
    clampPlaybackTime(rawTime, { updateTracker = true } = {}) {
      const duration = this.getActiveCoursewareDuration();
      const numeric = Math.max(Number(rawTime) || 0, 0);
      const safeTime = duration ? Math.min(numeric, duration) : numeric;
      if (updateTracker && safeTime > this.lastValidPlaybackTime) {
        this.lastValidPlaybackTime = safeTime;
      }
      return safeTime;
    },
    getFractionFromTime(timeValue) {
      const duration = this.getActiveCoursewareDuration();
      if (!duration) {
        return 0;
      }
      const safeTime = Math.min(Math.max(Number(timeValue) || 0, 0), duration);
      return safeTime / duration;
    },
    calculateLearningProgress(includeCurrent = false, currentFraction = 0) {
      if (this.isNewProgressMode) {
        return this.serverProgress || 0;
      }
      let completed = 0;
      let total = 0;
      this.videos.forEach((section) => {
        if (section.coursewares) {
          section.coursewares.forEach((courseware) => {
            total++;
            if (this.isCoursewareDone(courseware)) {
              completed += 1;
            } else if (
              includeCurrent &&
              this.activeVideo &&
              courseware.id == this.activeVideo
            ) {
              completed += Math.min(currentFraction, 1);
            }
          });
        }
      });
      if (!total) return 0;
      return Number(((completed / total) * 100).toFixed(2));
    },
    reportCourseProgress(
      progress,
      completed = false,
      force = false,
      retryCount = 0,
      currentTime = null,
      videoId = this.activeVideo
    ) {
      const courseId = this.$route.query && this.$route.query.id;
      if (!courseId || !videoId) {
        return Promise.resolve();
      }
      if (!this.ensureCourseLockActive()) {
        return Promise.resolve();
      }
      const normalized = Math.min(100, Math.max(0, Number(progress) || 0));
      if (normalized <= this.lastProgressReportValue && !completed) {
        return Promise.resolve();
      }
      if (!completed && !force) {
        const now = Date.now();
        if (
          normalized - this.lastProgressReportValue <
            this.progressIncrementThreshold &&
          now - this.lastProgressReportTime < this.progressReportThrottleMs
        ) {
          return Promise.resolve();
        }
      }
      this.lastProgressReportTime = Date.now();
      if (normalized > this.lastProgressReportValue) {
        this.lastProgressReportValue = normalized;
      }
      const params = new URLSearchParams();
      params.append("progress", normalized.toString());
      params.append("completed", completed ? "true" : "false");
      // 如果是完成上报且有 currentTime，一并传递给后端（解决进度同步失败的问题）
      if (completed && currentTime != null && currentTime > 0) {
        params.append("currentTime", currentTime.toString());
      }
      const url = `/api/my/course/coursewareDone/${courseId}/${videoId}?${params.toString()}`;

      return this.$https
        .put(url)
        .then(() => {
          // 上报成功，重置重试计数
          if (completed) {
            this.completionRetryCount = 0;
            this.pendingCompletionReport = null;
          }
        })
        .catch((error) => {
          // 如果是完成状态上报失败，且未超过最大重试次数，则重试
          if (completed && retryCount < this.maxCompletionRetries) {
            const delay = this.completionRetryDelayMs * Math.pow(2, retryCount); // 指数退避
            this.pendingCompletionReport = {
              progress: normalized,
              retryCount: retryCount + 1,
              currentTime: currentTime,
              delay: delay,
              videoId: videoId,
            };
            console.warn(
              `[课件完成上报] 失败，${delay}ms 后重试 (${retryCount + 1}/${
                this.maxCompletionRetries
              }):`,
              error
            );
            setTimeout(() => {
              if (this.pendingCompletionReport) {
                this.reportCourseProgress(
                  this.pendingCompletionReport.progress,
                  true,
                  true,
                  this.pendingCompletionReport.retryCount,
                  this.pendingCompletionReport.currentTime,
                  this.pendingCompletionReport.videoId
                );
              }
            }, delay);
          } else if (completed && retryCount >= this.maxCompletionRetries) {
            // 超过最大重试次数，记录到本地，等待页面加载时修复
            console.error(
              `[课件完成上报] 超过最大重试次数，将在页面加载时自动修复`
            );
            this.pendingCompletionReport = {
              progress: normalized,
              retryCount: retryCount,
              currentTime: currentTime,
              delay: 0,
              videoId: videoId,
            };
          }
          // 非完成状态的上报失败，静默忽略（不影响用户体验）
        });
    },
    maybeReportProgress(
      currentTime,
      isNormalized = false,
      videoId = this.activeVideo
    ) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio || !courseware.vedio.timeLength) {
        return;
      }
      const safeTime = isNormalized
        ? this.clampPlaybackTime(currentTime, { updateTracker: false })
        : this.clampPlaybackTime(currentTime);
      const fraction = this.getFractionFromTime(safeTime);
      const progress = this.calculateLearningProgress(true, fraction);
      this.reportCourseProgress(progress, false, false, 0, null, videoId);
    },
    flushProgress(force = false) {
      if (!this.ensureCourseLockActive()) {
        return Promise.resolve();
      }
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio || !courseware.vedio.timeLength) {
        return Promise.resolve();
      }
      const safeTime = this.clampPlaybackTime(this.lastValidPlaybackTime, {
        updateTracker: false,
      });
      const fraction = this.getFractionFromTime(safeTime);
      const progress = this.calculateLearningProgress(true, fraction);

      // 如果达到完成阈值但未标记为完成，尝试上报完成状态
      const duration = this.getActiveCoursewareDuration();
      const shouldMarkComplete =
        duration && safeTime / duration >= this.coursewareCompleteThreshold;

      // 如果是完成上报，传递 currentTime 确保后端能获取最新进度
      return this.reportCourseProgress(
        progress,
        shouldMarkComplete,
        force,
        0,
        shouldMarkComplete ? safeTime : null,
        this.activeVideo
      );
    },
    sendProgressOnUnloadKeepalive() {
      try {
        const courseId =
          this.videoId || (this.$route.query && this.$route.query.id);
        const videoId = this.activeVideo;
        if (!courseId || !videoId) return;
        const courseware = this.getActiveCourseware();
        if (!courseware || !courseware.vedio || !courseware.vedio.timeLength)
          return;
        const safeTime = this.clampPlaybackTime(this.lastValidPlaybackTime, {
          updateTracker: false,
        });
        if (!Number.isFinite(Number(safeTime)) || Number(safeTime) <= 0) return;
        let token = "";
        try {
          const raw = sessionStorage.getItem("userInfo");
          token = raw ? JSON.parse(raw)?.token || "" : "";
        } catch (_) {
          token = "";
        }
        const headers = {
          "Content-Type": "application/json;charset=UTF-8",
        };
        if (token) {
          headers.Authorization = "Bearer " + token;
          headers.token = token;
        }
        const url = `/api/my/course/coursewareProgress/${courseId}/${videoId}?currentTime=${encodeURIComponent(
          String(safeTime)
        )}`;
        fetch(url, {
          method: "PUT",
          keepalive: true,
          headers,
          body: "{}",
        });
      } catch (_) {}
    },
    handleBeforeUnload() {
      if (this.ensureCourseLockActive()) {
        this.sendProgressOnUnloadKeepalive();
      }
      this.releaseCourseLock();
    },
    timeupdate(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType != "liveing") {
        const targetVideoId = this.activeVideo;
        const targetCourseId =
          this.videoId || (this.$route.query && this.$route.query.id);
        if (!targetVideoId || !targetCourseId) {
          return;
        }
        const rawTime = player.cache_.currentTime;
        const safeTime = this.clampPlaybackTime(rawTime);
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: targetVideoId,
            time: safeTime || null,
          },
          () => {},
          true
        );
        if (!this.currentPlayTimer || !this.currentPlayStatus) {
          this.videos.forEach((el) => {
            if (el.id == this.actvieVideoSections) {
              el.coursewares.forEach((item) => {
                if (item.id == targetVideoId && !this.isCoursewareDone(item)) {
                  this.currentPlayTimer = item.vedio.timeLength;
                  item.currentTime = safeTime;
                }
              });
            }
          });
          this.currentPlayStatus = this.currentPlayTimer
            ? safeTime / this.currentPlayTimer >= 1.0
            : false;
          if (this.currentPlayStatus) {
            this.onPlayerEnded();
          }
          VideocurrentTime = safeTime;
        }

        // 周期性向后端上报课件播放进度（单位：秒），用于统一的完成判定
        const now = Date.now();
        if (
          !this.lastCoursewareProgressReportTime ||
          now - this.lastCoursewareProgressReportTime >=
            this.coursewareProgressThrottleMs
        ) {
          this.lastCoursewareProgressReportTime = now;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${targetCourseId}/${targetVideoId}?currentTime=${encodeURIComponent(
                String(safeTime)
              )}`,
              {}
            )
            .catch(() => {});
        }

        // 当本课件已观看比例首次达到阈值时，尝试触发一次“完成”上报
        const duration = this.getActiveCoursewareDuration();
        if (
          duration &&
          !this.hasTriedCompleteOnce &&
          safeTime / duration >= this.coursewareCompleteThreshold
        ) {
          this.hasTriedCompleteOnce = true;
          // 先尝试同步当前进度到后端
          // 同时在完成上报中也传递 currentTime，作为双重保障
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${targetCourseId}/${targetVideoId}?currentTime=${encodeURIComponent(
                String(safeTime)
              )}`,
              {}
            )
            .finally(() => {
              // 无论进度上报成功与否，都尝试上报完成状态
              // 传递 currentTime 确保后端能获取最新进度（即使进度同步失败）
              const fraction = this.getFractionFromTime(safeTime);
              const progress = this.calculateLearningProgress(true, fraction);
              this.reportCourseProgress(
                progress,
                true,
                true,
                0,
                safeTime,
                targetVideoId
              );
            });
        }

        this.maybeReportProgress(safeTime, true, targetVideoId);
      }
    },
    formatterData(time) {
      const sec = Number(time);
      if (!Number.isFinite(sec) || sec <= 0) {
        return "-";
      }
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = Math.floor(sec % 60);
      const parts = [];
      if (h > 0) parts.push(h + "时");
      if (m > 0) parts.push(m + "分");
      if (s > 0 || parts.length === 0) parts.push(s + "秒");
      return parts.join("");
    },
    buildPlayableSrc(url) {
      if (!url || typeof url !== "string") return "";
      const u = url.trim();
      if (!u) return "";
      if (/^https?:\/\//i.test(u)) return u;
      return (
        (this.httpsLocation || "").replace(/\/$/, "") +
        (u.startsWith("/") ? u : "/" + u)
      );
    },
    /** 课件是否具有可加载的视频地址（不经修改即复用现有播放校验） */
    isCoursewarePlayable(courseware) {
      if (!courseware || !courseware.vedio || !courseware.vedio.url) {
        return false;
      }
      return !!this.buildPlayableSrc(courseware.vedio.url);
    },
    /**
     * 学习模式下默认应预加载的课件：优先首个未完成且可播放，否则首个可播放。
     * 仅在 needStudyPlan+planLocked 使用 planSections；无需选课则用完整 videos。
     */
    resolveDefaultCoursewareForLearningMode() {
      let sections = [];
      if (this.needStudyPlan && this.planLocked) {
        sections = this.planSections;
      } else if (!this.needStudyPlan) {
        sections = this.videos;
      } else {
        return null;
      }
      if (!Array.isArray(sections) || sections.length === 0) {
        return null;
      }
      const orderedCoursewares = [];
      sections.forEach((sec) => {
        (sec && Array.isArray(sec.coursewares) ? sec.coursewares : []).forEach(
          (cw) => {
            orderedCoursewares.push(cw);
          }
        );
      });
      if (!orderedCoursewares.length) {
        return null;
      }
      let firstPlayable = null;
      for (let i = 0; i < orderedCoursewares.length; i++) {
        const cw = orderedCoursewares[i];
        if (!this.isCoursewarePlayable(cw)) {
          continue;
        }
        if (firstPlayable == null) {
          firstPlayable = cw;
        }
        if (!this.isCoursewareDone(cw)) {
          return cw;
        }
      }
      return firstPlayable;
    },
    tryAutoloadDefaultCourseware(courseId) {
      if (courseId == null || courseId === "") {
        return;
      }
      if (this.isStudyPlanBuilder) {
        return;
      }
      const key = String(courseId);
      if (this.autoCoursewareBootstrappedKey === key) {
        return;
      }
      const target = this.resolveDefaultCoursewareForLearningMode();
      if (!target) {
        this.autoCoursewareBootstrappedKey = key;
        return;
      }
      this.viewViedo(target);
      console.log(
        "[curriculumDetails] 自动寻址成功，选中的课件ID为：",
        target.id
      );
      this.autoCoursewareBootstrappedKey = key;
    },
    initData() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只获取当前用户的缓存数据
      const videoHistoryMap = {};
      list
        .filter((el) => el.userName === userInfo.userName)
        .map((el) => (videoHistoryMap[el.activeVideoID] = el.time));
      const id = this.$route.query && this.$route.query.id;
      this.$https
        .get("/api/my/course/details/" + id)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            this.autoCoursewareBootstrappedKey = "";
            this.description = data.description;
            this.viewTitle = data.title || this.viewTitle;
            this.playerOptions.sources = [];
            this.activeVideo = "";
            this.actvieVideoSections = 0;
            this.activelives = "";
            this.videoType = "";
            // 选课字段
            const totalHRaw =
              data.totalClassHours != null ? Number(data.totalClassHours) : 0;
            this.totalClassHours = Number.isFinite(totalHRaw) ? totalHRaw : 0;
            this.requiredClassHours = data.requiredClassHours || 0;
            this.electiveTargetClassHours = data.electiveTargetClassHours || 0;
            this.planLocked = data.planLocked || false;
            this.selectedElectives = data.selectedElectives || [];
            this.selectedRequired = data.selectedRequired || [];
            this.localSelectedElectives = [...(data.selectedElectives || [])];
            this.localSelectedRequired = [...(data.selectedRequired || [])];
            this.courseUsesDualQuota = !!data.courseUsesDualQuota;
            this.requiredSelectionImplicit = !!data.requiredSelectionImplicit;
            this.electiveSelectionImplicit = !!data.electiveSelectionImplicit;
            this.isNewProgressMode =
              this.totalClassHours > 0 || this.courseUsesDualQuota;
            this.serverProgress = data.progress || 0;
            const hasElectives = data.coursewares?.some(
              (cw) => cw.required === false || cw.isRequired === false
            );
            this.needStudyPlan =
              !!hasElectives &&
              (this.courseUsesDualQuota || this.totalClassHours > 0);
            this.planNeedsResubmit = !!data.planNeedsResubmit;
            this.isCourseDataInvalid = !!data.isCourseDataInvalid;
            if (!this.planNeedsResubmit) {
              this.planResubmitOverlayDismissed = false;
            }
            // 直播
            const lives = Array.isArray(data.lives) ? data.lives : [];
            let _lives = lives.map((el) => {
              return {
                ...el,
                ...this.judeLives(res, el),
              };
            });
            this.lives = _lives
              .filter((el) => el.living)
              .concat(_lives.filter((el) => !el.living));
            // 进入页面不自动播放直播，由用户点击直播条目后再打开
            // 视频
            // 记录初始化时接口返回的已完成视频ID，这些视频不需要再次调用done接口
            const initialDoneVideoIds = new Set();
            const coursewares = Array.isArray(data.coursewares)
              ? data.coursewares
              : [];
            coursewares.forEach((cw) => {
              if (this.isCoursewareDone(cw)) {
                initialDoneVideoIds.add(cw.id);
              }
            });
            this.initialDoneVideoIds = initialDoneVideoIds;

            const courseSections = Array.isArray(data.courseSections)
              ? data.courseSections
              : [];
            this.videos = courseSections.map((el) => {
              return {
                ...el,
                coursewares: coursewares
                  .filter((item) => item.sectionId == el.id)
                  .map((val) => {
                    val.currentTime = videoHistoryMap[val.id];
                    return val;
                  }),
              };
            });
            // 兼容历史遗留数据：检查并修复已学完但未标记完成的课件
            this.fixHistoricalCoursewareProgress(coursewares, id);
            this.$nextTick(() => {
              this.applyImplicitDualQuotaSelections();
              this.tryAutoloadDefaultCourseware(id);
            });
          } else {
            this.$message.error(res.debug);
          }
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.debug ||
            error?.response?.data?.message ||
            error?.message ||
            "加载课程详情失败，请稍后重试";
          this.$message.error(msg);
        });
    },
    // 修复历史遗留数据：自动补传已完成但后台未标记的课件
    // 同时处理网络失败导致的上报失败情况
    fixHistoricalCoursewareProgress(coursewares, courseId) {
      if (!coursewares || !Array.isArray(coursewares) || !courseId) {
        return;
      }
      coursewares.forEach((courseware) => {
        // 检查条件：课件有视频时长，且播放进度达到完成阈值（80%），但后台未标记为完成
        if (
          courseware.vedio &&
          courseware.vedio.timeLength &&
          courseware.currentTime != null &&
          courseware.currentTime / courseware.vedio.timeLength >=
            this.coursewareCompleteThreshold &&
          !this.isCoursewareDone(courseware)
        ) {
          // 计算总学习进度：已完成的课程 + 当前课件（假设已完成）/全部课程*100
          let completedCourses = 0;
          let totalCourses = 0;
          coursewares.forEach((cw) => {
            totalCourses++;
            if (this.isCoursewareDone(cw) || cw.id === courseware.id) {
              completedCourses++;
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 为当前课件单独调用接口，补传completed=true
          // 传递 currentTime 确保后端能获取最新进度
          const params = new URLSearchParams();
          params.append("progress", learningProgress.toString());
          params.append("completed", "true");
          params.append(
            "currentTime",
            (
              courseware.currentTime ||
              courseware.vedio?.timeLength ||
              0
            ).toString()
          );
          const url = `/api/my/course/coursewareDone/${courseId}/${
            courseware.id
          }?${params.toString()}`;
          this.$https
            .put(url)
            .then(() => {
              console.log(`[自动修复] 课件 ${courseware.id} 完成状态已修复`);
            })
            .catch((error) => {
              console.warn(
                `[自动修复] 课件 ${courseware.id} 完成状态修复失败，将在下次页面加载时重试:`,
                error
              );
              // 失败时，依赖页面刷新时的再次检查
            });
        }
      });
    },
    // 播放回调
    onPlayerPlay() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        this.$refs.videoPlayer.player.currentTime(this.currentTime);
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
          },
          (list, listIndex) => {
            const resumeTime = list[listIndex].time || 0;
            const safeTime = this.clampPlaybackTime(resumeTime);
            this.$refs.videoPlayer.player.currentTime(safeTime);
          }
        );
      }
    },
    onPlayerPlaying() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (!this.playerPlaying) {
        this.playerPlaying = true;
        this.onPlayerPlay();
        // this.$refs.videoPlayer.player.currentTime(this.currentTime);
      }
    },
    // 暂停回调
    onPlayerPause(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      const safeTime = this.clampPlaybackTime(player.cache_.currentTime);
      this.setVidoData(
        {
          detailsID: this.videoId,
          activeVideoID: this.activeVideo,
          time: safeTime,
        },
        () => {},
        true
      );
      this.flushProgress(true);
    },
    onPlayerSeeking() {
      // 已取消单窗口限制，但保留快进检测机制
      if (this.videoType === "liveing") {
        return;
      }
      const playerInstance = this.$refs.videoPlayer?.player;
      if (!playerInstance) return;
      const requestedTime = playerInstance.currentTime();
      const tolerance = 0.5;
      if (requestedTime > this.lastValidPlaybackTime + tolerance) {
        this.seekingBlocked = true;
        const restoreTime = this.lastValidPlaybackTime;
        if (this.seekRestoreTimer) {
          clearTimeout(this.seekRestoreTimer);
        }
        this.seekRestoreTimer = setTimeout(() => {
          playerInstance.currentTime(restoreTime);
          this.seekRestoreTimer = null;
        }, 0);
        const now = Date.now();
        if (now - this.lastSeekWarningAt > 3000 && this.$message) {
          this.$message.warning("当前课程不支持快进");
          this.lastSeekWarningAt = now;
        }
      }
    },
    onPlayerSeeked() {
      if (this.seekingBlocked) {
        this.seekingBlocked = false;
      }
    },
    // 视频播完回调
    onPlayerEnded() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        let target = this.lives[this.activelives];
        let url =
          target.vedios.length > target.livingIndex + 1
            ? target.vedios[target.livingIndex + 1].url
            : "";
        target.livingIndex += 1;
        if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
        const playUrl = url ? this.buildPlayableSrc(url) : "";
        const isHls = playUrl.indexOf(".m3u8") > 0;
        this.playerOptions.sources = [
          {
            type: isHls ? "application/x-mpegURL" : "video/mp4",
            src: playUrl,
          },
        ];
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: 0,
          },
          () => {},
          true
        );
        this.lastValidPlaybackTime = 0;
        let data = this.videos
          .find((el) => el.id == this.actvieVideoSections)
          .coursewares.find((el) => el.id == this.activeVideo);
        if (this.isCoursewareDone(data)) return;
        const learningProgress = this.calculateLearningProgress(true, 1);
        // 视频播放完成，传递完整的视频时长作为 currentTime
        const videoDuration = data.vedio?.timeLength || 0;
        this.reportCourseProgress(
          learningProgress,
          true,
          true,
          0,
          videoDuration,
          data.id
        ).then(() => {
          // 以服务器为准：重新拉取课程详情，用服务端返回的 isDone 更新列表，只有成功落库才算“已完成”
          const id = this.$route.query && this.$route.query.id;
          if (id) {
            this.$https.get("/api/my/course/details/" + id).then((res) => {
              if (res.success && res.data && res.data.coursewares) {
                const map = {};
                res.data.coursewares.forEach((cw) => {
                  map[cw.id] = this.isCoursewareDone(cw);
                });
                this.videos.forEach((section) => {
                  (section.coursewares || []).forEach((cw) => {
                    if (Object.prototype.hasOwnProperty.call(map, cw.id)) {
                      cw.isDone = map[cw.id];
                      cw.done = map[cw.id];
                    }
                  });
                });
                this.$forceUpdate && this.$forceUpdate();
              }
            });
          }
        });
      }
    },
    // 直播
    viewIives(item, i) {
      this.playerPlaying = false;
      this.videoType = "liveing";
      if (!item.living) {
        this.$message({
          message: "尚未开始或已经结束",
          type: "warning",
        });
        return;
      }
      this.viewTitle = item.title;
      this.activelives = i;
      const url =
        item.vedios[item.livingIndex] && item.vedios[item.livingIndex].url;
      if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
      const playUrl = this.buildPlayableSrc(item.vedios[item.livingIndex].url);
      const isHls = playUrl.indexOf(".m3u8") > 0;
      this.playerOptions.sources = [
        {
          type: isHls ? "application/x-mpegURL" : "video/mp4",
          src: playUrl,
        },
      ];
      let currentTime =
        item.currentTime + (moment().valueOf() - item.ajaxTime) / 1000;
      setTimeout(() => {
        this.$refs.videoPlayer.player.currentTime(currentTime);
      }, 500);
      this.$https
        .put(
          "/api/my/course/liveRecord/" + this.$route.query.id + "/" + item.id
        )
        .then((res) => {
          console.log("liveRecord");
          console.log(res);
        })
        .catch((err) => {
          console.log("liveRecord");
          console.log(err);
        });
    },
    coursewareProgressText(s) {
      const len =
        s.vedio && s.vedio.timeLength ? Number(s.vedio.timeLength) : 0;
      if (s.currentTime != null && len > 0) {
        const pct = (s.currentTime / len > 1 ? 1 : s.currentTime / len) * 100;
        return "（" + pct.toFixed(2) + "%）";
      }
      return this.isCoursewareDone(s) ? "（100%）" : "";
    },
    studyPlanRowChecked(s) {
      if (!this.courseUsesDualQuota) {
        return this.localSelectedElectives.includes(s.id);
      }
      return this.isCoursewareRequired(s)
        ? this.localSelectedRequired.includes(s.id)
        : this.localSelectedElectives.includes(s.id);
    },
    applyImplicitDualQuotaSelections() {
      if (!this.needStudyPlan || !this.courseUsesDualQuota || this.planLocked) {
        return;
      }
      if (this.requiredSelectionImplicit) {
        this.localSelectedRequired = this.builderRequiredPool.map(
          (cw) => cw.id
        );
      }
      if (this.electiveSelectionImplicit) {
        this.localSelectedElectives = this.builderElectivePool.map(
          (cw) => cw.id
        );
      }
    },
    toggleStudyPlanCourseware(coursewareId, checked) {
      const cw = this.findCoursewareById(coursewareId);
      if (!cw || !this.needStudyPlan || this.planLocked) return;
      if (this.courseUsesDualQuota) {
        if (this.isCoursewareRequired(cw) && this.requiredSelectionImplicit) {
          return;
        }
        if (!this.isCoursewareRequired(cw) && this.electiveSelectionImplicit) {
          return;
        }
        if (this.isCoursewareRequired(cw)) {
          if (checked) {
            if (!this.localSelectedRequired.includes(coursewareId)) {
              this.localSelectedRequired.push(coursewareId);
            }
          } else {
            this.localSelectedRequired = this.localSelectedRequired.filter(
              (id) => id !== coursewareId
            );
          }
        } else if (checked) {
          if (!this.localSelectedElectives.includes(coursewareId)) {
            this.localSelectedElectives.push(coursewareId);
          }
        } else {
          this.localSelectedElectives = this.localSelectedElectives.filter(
            (id) => id !== coursewareId
          );
        }
        return;
      }
      if (this.isCoursewareRequired(cw)) return;
      if (checked) {
        if (!this.localSelectedElectives.includes(coursewareId)) {
          this.localSelectedElectives.push(coursewareId);
        }
      } else {
        this.localSelectedElectives = this.localSelectedElectives.filter(
          (id) => id !== coursewareId
        );
      }
    },
    findCoursewareById(coursewareId) {
      for (const section of this.videos || []) {
        const found = (section.coursewares || []).find(
          (c) => c.id === coursewareId
        );
        if (found) return found;
      }
      return null;
    },
    acknowledgePlanResubmit() {
      this.planResubmitOverlayDismissed = true;
      this.planLocked = false;
      this.localSelectedElectives = [...(this.selectedElectives || [])];
      this.localSelectedRequired = [...(this.selectedRequired || [])];
      this.$nextTick(() => this.applyImplicitDualQuotaSelections());
    },
    leaveCourseListForInvalidPlan() {
      this.$router.push({ path: "/curriculum" });
    },
    buildStudyPlanPayload() {
      if (this.courseUsesDualQuota) {
        return {
          selectedRequiredCoursewareIds: [...this.localSelectedRequired],
          selectedElectiveCoursewareIds: [...this.localSelectedElectives],
        };
      }
      return {
        selectedCoursewareIds: [...this.localSelectedElectives],
      };
    },
    async submitStudyPlan() {
      if (this.studyPlanSubmitLoading) return;
      if (!this.needStudyPlan || this.planLocked) return;
      if (!this.canSubmitPlan) return;

      if (this.courseUsesDualQuota) {
        const eps = STUDY_PLAN_HOUR_EPS;
        if (
          !this.requiredSelectionImplicit &&
          this.selectedRequiredHours < this.requiredClassHours - eps
        ) {
          this.$message.warning("必修课已选课时不足，请继续勾选直至达到目标");
          return;
        }
        if (
          !this.electiveSelectionImplicit &&
          this.selectedElectiveHours < this.electiveTargetClassHours - eps
        ) {
          this.$message.warning("选修课已选课时不足，请继续勾选直至达到目标");
          return;
        }
      }

      try {
        await ElMessageBox.confirm(
          "提交后将正式锁定并开始计算学习进度，您将无法自行修改课件组合。是否确认提交？",
          "确认提交？",
          {
            type: "warning",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        );
      } catch {
        return;
      }

      const courseId = this.$route.query && this.$route.query.id;
      this.studyPlanSubmitLoading = true;
      try {
        await this.$https.put(
          `/api/my/course/studyPlan/${courseId}`,
          this.buildStudyPlanPayload()
        );
        this.$message.success("提交成功！");
        this.planResubmitOverlayDismissed = false;
        this.initData();
      } catch (e) {
        const status = e && e.status;
        if (status === 409) {
          this.$message.warning("系统正在处理您的提交，请勿重复点击");
        } else {
          const msg =
            (e && e.data && (e.data.debug || e.data.message)) ||
            "提交失败，请重试";
          this.$message.error(msg);
        }
      } finally {
        this.studyPlanSubmitLoading = false;
      }
    },
    // 视频
    viewViedo(item) {
      if (!item || !item.vedio || !item.vedio.url) {
        this.$message.warning("该课件暂无可播放视频，请稍后再试或联系管理员");
        return;
      }
      if (this.needStudyPlan && !this.planLocked) {
        this.$message.warning(
          this.courseUsesDualQuota
            ? "请先完成必修课与选修课选择并提交后再开始学习！"
            : "请先挑选选修课并提交后再开始学习！"
        );
        return;
      }
      if (this.needStudyPlan && this.planLocked) {
        const isInPlan = this.courseUsesDualQuota
          ? (this.selectedRequired || []).includes(item.id) ||
            this.selectedElectives.includes(item.id)
          : (item.required !== false && item.isRequired !== false) ||
            this.selectedElectives.includes(item.id);
        if (!isInPlan) {
          this.$message.info(
            "您正在观看未选修的拓展课件，该部分学习不计入总学时进度哦~"
          );
        }
      }
      this.playerPlaying = false;
      this.currentPlayTimer = 0;
      this.currentPlayStatus = false;
      this.hasTriedCompleteOnce = false;
      this.videoType = "video";
      this.activelives = null;
      this.viewTitle = item.title;
      this.actvieVideoSections = item.sectionId;
      this.activeVideo = item.id;
      // 如果本地状态是已看完，且不是初始化接口返回的已完成状态，切换时调用done接口，避免网络问题导致状态未同步
      // 参照移动端逻辑：如果初始化接口返回的数据中 isDone=true，说明后端已经确认完成，不需要再调用
      if (
        this.isCoursewareDone(item) &&
        !this.initialDoneVideoIds.has(item.id)
      ) {
        const courseId = this.$route.query && this.$route.query.id;
        if (courseId && item.id) {
          // 计算总学习进度
          let completedCourses = 0;
          let totalCourses = 0;
          this.videos.forEach((section) => {
            if (section.coursewares) {
              section.coursewares.forEach((courseware) => {
                totalCourses++;
                if (this.isCoursewareDone(courseware)) {
                  completedCourses++;
                }
              });
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 调用done接口，传递 currentTime 确保后端能获取最新进度
          const itemCurrentTime =
            item.currentTime || item.vedio?.timeLength || 0;
          this.$https
            .put(
              `/api/my/course/coursewareDone/${courseId}/${item.id}?progress=${learningProgress}&completed=true&currentTime=${itemCurrentTime}`
            )
            .catch(() => {
              // 静默失败，不影响用户体验
            });
        }
      }
      const resumeTime = item.currentTime || 0;
      const safeTime = this.clampPlaybackTime(resumeTime);
      this.lastValidPlaybackTime = safeTime;
      item.currentTime = safeTime;
      this.seekingBlocked = false;
      if (this.seekRestoreTimer) {
        clearTimeout(this.seekRestoreTimer);
        this.seekRestoreTimer = null;
      }
      const playUrl = this.buildPlayableSrc(item.vedio.url);
      if (!playUrl) {
        this.$message.warning("该课件暂无可播放视频，请稍后再试或联系管理员");
        return;
      }
      const isHls = playUrl.indexOf(".m3u8") > 0;
      this.playerOptions.sources = [
        {
          type: isHls ? "application/x-mpegURL" : "video/mp4",
          src: playUrl,
        },
      ];
    },
    // 判断是否有直播数据
    judeLives(res, item) {
      let isAlive = false;
      const startTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.startTime + ":00"
      ).valueOf();
      const endTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
      ).valueOf();
      let aliveDate;
      // 判断日期
      Object.keys(item.dateSettings).forEach((el) => {
        let target = item.dateSettings[el];
        if (target) {
          switch (el) {
            case "monthDays":
              if (target.includes(moment(parseInt(res.stime)).format("DD"))) {
                isAlive = true;
              }
              aliveDate =
                "每月" +
                target.map((el) => el + 1).join(",") +
                "号 " +
                item.startTime +
                " 开始";
              break;
            case "specDays":
              target = target.map((el) =>
                moment(parseInt(el)).format("YYYY-MM-DD")
              );
              if (
                target.includes(
                  moment(parseInt(res.stime)).format("YYYY-MM-DD")
                )
              ) {
                isAlive = true;
              }
              aliveDate = target.join(",") + " " + item.startTime + " 开始";
              break;
            case "weeklyDays":
              if (target.includes(moment(parseInt(res.stime)).day())) {
                isAlive = true;
              }
              aliveDate =
                "每周" +
                target.map((el) => getWeekDate(el)).join(",") +
                " " +
                item.startTime +
                " 开始";
              break;
          }
        }
      });
      // 判断时间
      if (isAlive) {
        if (!(res.stime >= startTime && res.stime <= endTime)) {
          isAlive = false;
        }
      }
      // 计算直播播放时间,直播开始时间减去当前服务器时间得到已经开始的时间
      let currentTime = (res.stime - startTime) / 1000;
      let _currentTime = 0;
      let timeLength = 0;
      let livingIndex = 0;
      if (isAlive) {
        for (let i = 0; i <= item.vedios.length; i++) {
          if (timeLength >= currentTime) {
            livingIndex = i;
            _currentTime =
              item.vedios[i - 1].timeLength - (timeLength - currentTime);
            break;
          }
          timeLength += item.vedios[i].timeLength;
        }
      }
      return {
        currentTime: _currentTime,
        living: isAlive,
        // living: true,
        livingIndex: livingIndex ? livingIndex - 1 : 0,
        aliveDate: aliveDate,
        stime: res.stime,
        ajaxTime: moment().valueOf(),
      };
    },
    setVidoData(options, callBack, isSet = false) {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      // 如果是直接不保存数据
      if (this.videoType == "liveing") {
        return false;
      }
      // 保存当前数据到本地（用于保存回显视频地址和位置）
      let list = this.$storage.getStorage("vidoDataList") || [];
      // 只查找当前用户的缓存记录
      let listIndex = list.findIndex(
        (p) =>
          Number(p.detailsID) === Number(options.detailsID) &&
          Number(p.activeVideoID) === Number(options.activeVideoID) &&
          userInfo.userName == p.userName
      );
      if (listIndex !== -1) {
        if (callBack) {
          callBack([...list], listIndex);
        }
        if (isSet) {
          list[listIndex] = {
            detailsID: Number(options.detailsID),
            activeVideoID: Number(options.activeVideoID),
            time: options.time != null ? options.time : list[listIndex].time,
            timeLength: options.timeLength || 0,
            userName: userInfo.userName,
          };
        }
      } else {
        list.push({
          detailsID: Number(options.detailsID),
          activeVideoID: Number(options.activeVideoID),
          time: options.time || 0,
          timeLength: options.timeLength || 0,
          userName: userInfo.userName,
        });
      }
      this.$storage.setStorage([
        {
          key: "vidoDataList",
          value: list,
        },
      ]);
    },
  },
};

function getWeekDate(date) {
  const list = [
    { name: "星期日", value: 0 },
    { name: "星期一", value: 1 },
    { name: "星期二", value: 2 },
    { name: "星期三", value: 3 },
    { name: "星期四", value: 4 },
    { name: "星期五", value: 5 },
    { name: "星期六", value: 6 },
  ];
  return list.find((el) => el.value == date).name;
}
</script>
<style lang="less">
.curriculumDetails {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
  // overflow: hidden;
  // overflow: hidden;
  .media {
    position: absolute;
    left: 0;
    right: 350px;
    top: 0;
    bottom: 0;
    border: 1px solid #e4e7ed;
    display: flex;
    flex-direction: column;
    .title {
      color: #677897;
      font-size: 16px;
      font-weight: bold;
      padding: 10px;
      height: 36px;
      flex-shrink: 0;
      box-sizing: border-box;
    }
    .media-player-shell {
      flex: 1;
      min-height: 0;
      background: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      box-sizing: border-box;
    }
    .media-player-inner {
      position: relative;
      width: 100%;
      max-height: 100%;
      aspect-ratio: 16 / 9;
    }
    .media-video-player {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .media-video-player.video-player .video-js,
    .media-video-player .video-js {
      width: 100% !important;
      height: 100% !important;
      padding-top: 0 !important;
    }
    .media-player-empty {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 24px 20px;
      box-sizing: border-box;
      overflow: hidden;
      background: radial-gradient(
        ellipse 92% 72% at 50% 40%,
        rgba(10, 115, 197, 0.16) 0%,
        rgba(8, 28, 56, 0.5) 42%,
        #050506 100%
      );
      border: 1px solid rgba(255, 255, 255, 0.07);
      &__glow {
        position: absolute;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background: rgba(10, 115, 197, 0.22);
        filter: blur(40px);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -56%);
        pointer-events: none;
      }
      &__icon-wrap {
        position: relative;
        width: 76px;
        height: 76px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.14);
        background: rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 22px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
      }
      &__icon {
        font-size: 38px;
        color: rgba(186, 218, 255, 0.95);
      }
      &__title {
        position: relative;
        margin: 0 0 10px;
        font-size: 17px;
        font-weight: 600;
        letter-spacing: 0.03em;
        color: rgba(255, 255, 255, 0.93);
      }
      &__hint {
        position: relative;
        margin: 0;
        max-width: 300px;
        font-size: 13px;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.52);
      }
    }
    .title2 {
      background: #d4d8df;
      text-align: center;
      color: #da2828;
      font-size: 16px;
      font-weight: bold;
      padding: 10px;
    }
    .vjs-progress-control {
      display: none !important;
    }
    .vjs-fullscreen-control {
      position: absolute;
      right: 0;
    }
    .aliving {
      .vjs-play-control {
        display: none !important;
      }
      .vjs-current-time {
        display: none !important;
      }
      .vjs-tech {
        pointer-events: none;
      }
      .timeout-lives {
        text-align: center;
      }
    }
  }
  .media-list {
    position: absolute;
    width: 350px;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0 20px;
    border-top: 1px solid #e4e7ed;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    &.media-list--plan-builder {
      left: 0;
      right: 0;
      width: 100%;
      max-width: 100%;
    }
    .plan-builder-header {
      flex-shrink: 0;
      font-size: 16px;
      font-weight: 600;
      color: #677897;
      padding: 12px 0 4px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 4px;
    }
    > .el-tabs {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    > .el-tabs .el-tabs__header {
      flex-shrink: 0;
    }
    > .el-tabs .el-tabs__content {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
    > .el-tabs .el-tabs__content .el-tab-pane {
      height: 100%;
      overflow: hidden;
    }
    .tab-pane-intro {
      height: 100%;
      overflow-y: auto;
      padding: 10px 0;
      box-sizing: border-box;
      word-break: break-word;
    }
    .tab-pane-course {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
    }
    .course-live-block {
      flex-shrink: 0;
    }
    .course-locked-scroll {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      background: #f5f7fa;
      padding: 8px 4px 12px;
      box-sizing: border-box;
    }
    .catalog-plan-section {
      padding: 4px 0 8px;
    }
    .catalog-plan-section--divider {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid #e8eaed;
    }
    .catalog-flat-root {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #f5f7fa;
    }
    .catalog-flat-scroll {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 12px 4px;
      box-sizing: border-box;
      background: #f5f7fa;
    }
    .catalog-flat-scroll--with-sticky {
      padding-top: 0;
    }
    .plan-hours-sticky-bar {
      position: sticky;
      top: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 14px;
      margin-bottom: 0;
      background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
      border: 1px solid #dce6f5;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);

      .bar-title {
        font-size: 12px;
        color: #909399;
        white-space: nowrap;
        margin-right: 4px;
      }

      .bar-cards {
        display: flex;
        gap: 8px;
        flex: 1;
        flex-wrap: wrap;
      }

      .bar-card {
        flex: 1;
        min-width: 140px;
        background: #fff;
        border: 1px solid #ebedf0;
        border-left: 3px solid #409eff;
        border-radius: 6px;
        padding: 8px 10px;
        transition: border-color 0.3s;

        &--ok {
          border-left-color: #67c23a;
        }
        &--warn {
          border-left-color: #e6a23c;
        }

        .bar-card__label {
          font-size: 11px;
          color: #909399;
          margin-bottom: 4px;
        }

        .bar-card__nums {
          display: flex;
          align-items: baseline;
          gap: 3px;
          margin-bottom: 5px;
          .current {
            font-size: 17px;
            font-weight: 700;
            color: #303133;
          }
          .divider {
            font-size: 12px;
            color: #c0c4cc;
          }
          .target {
            font-size: 12px;
            color: #909399;
          }
        }

        .bar-card__track {
          height: 5px;
          background: #f0f2f5;
          border-radius: 99px;
          overflow: hidden;
          .bar-card__fill {
            height: 100%;
            border-radius: 99px;
            background: #e6a23c;
            transition: width 0.4s ease, background 0.3s;
            &--ok {
              background: #67c23a;
            }
          }
        }

        .bar-card__status {
          font-size: 11px;
          margin-top: 4px;
          &--warn {
            color: #e6a23c;
          }
          &--ok {
            color: #67c23a;
            font-weight: 600;
          }
        }
      }
    }
    .catalog-section-title {
      margin: 0 0 12px;
      padding: 0;
      color: #677897;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.4;
    }
    .video-item {
      cursor: pointer;
      line-height: 1.45;
      white-space: normal;
      overflow: visible;
      border-bottom: 1px solid #e8eaed;
      padding-bottom: 12px;
      margin-bottom: 12px;
      font-weight: normal;
      color: #303133;
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
      .video-title {
        font-size: 14px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 10px;
        padding-left: 8px;
        border-left: 3px solid rgba(10, 115, 197, 0.35);
        line-height: 1.45;
        white-space: normal;
        overflow: visible;
      }
      .video-item-list {
        margin-left: 0;
        margin-bottom: 10px;
        padding: 10px 12px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        box-sizing: border-box;
        white-space: normal;
        overflow: visible;
        transition: background 0.15s ease, box-shadow 0.15s ease;
        &:last-child {
          margin-bottom: 0;
        }
        &.active {
          background: rgba(10, 115, 197, 0.06);
          border-color: rgba(10, 115, 197, 0.35);
          box-shadow: inset 3px 0 0 #0a73c5;
          .video-item-list__progress {
            color: #606266;
          }
          .video-item-list__progress-label {
            color: #909399;
          }
        }
      }
      .video-item-list__progress {
        margin: 0;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
        font-size: 12px;
        line-height: 1.5;
        color: #606266;
      }
      .video-item-list__progress-label {
        color: #909399;
      }
      .video-item-list__top {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
        box-sizing: border-box;
      }
      .video-item-list__meta {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
      }
      .main-title {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 6px;
        .main-title-icon {
          flex-shrink: 0;
          margin-top: 2px;
        }
        .main-title-tag {
          flex-shrink: 0;
          margin-top: 2px;
        }
        .main-title-text {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-word;
          line-height: 1.45;
          font-size: 14px;
        }
        .courseware-author {
          flex-basis: 100%;
          min-width: 0;
          color: #909399;
          font-size: 12px;
          line-height: 1.35;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .timer {
        text-align: right;
        white-space: nowrap;
        color: #969799;
        font-size: 13px;
      }
      .status-done {
        display: inline-block;
        margin-left: 4px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        background: #52c41a;
        border-radius: 4px;
      }
      .status-undone {
        margin-left: 4px;
        color: #666;
        font-size: 12px;
      }
    }
    .ailve-item {
      cursor: pointer;
      line-height: 30px;
      border-bottom: 1px solid #e4e7ed;
      color: #b0b9ca;
      font-weight: bold;
      font-size: 14px;
      .description {
        font-size: 12px;
        font-weight: normal;
      }
    }
    .active {
      color: #0a73c5;
      .description {
        color: #677897;
      }
    }
    .class-hour-tag {
      display: inline-block;
      font-size: 12px;
      color: #606266;
      margin-left: 0;
      background: #f0f7fc;
      padding: 3px 8px;
      border-radius: 4px;
      line-height: 1.35;
      vertical-align: middle;
      border: 1px solid rgba(10, 115, 197, 0.22);
      border-left: 3px solid rgba(10, 115, 197, 0.55);
      font-weight: 500;
    }
    .class-hour-num {
      font-weight: 700;
      color: #303133;
    }
    .study-plan-dashboard {
      flex-shrink: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin-bottom: 14px;
    }
    .study-plan-dashboard__pool {
      background: linear-gradient(135deg, #f7fafc 0%, #eef3f9 100%);
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 12px 14px;
      box-sizing: border-box;
    }
    .study-plan-dashboard__pool--legacy {
      grid-column: 1 / -1;
    }
    .study-plan-dashboard__label {
      font-size: 13px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 8px;
    }
    .study-plan-dashboard__value {
      font-size: 13px;
      color: #606266;
      line-height: 1.55;
    }
    .study-plan-dashboard__value--met {
      color: #67c23a;
    }
    .study-plan-dashboard__value--pending {
      color: #606266;
    }
    .study-plan-dashboard__sep {
      margin: 0 8px;
      color: #dcdfe6;
    }
    .study-plan-dashboard__hint {
      margin-left: 6px;
      font-size: 12px;
    }
    .study-plan-dashboard__hint--warn {
      color: #e6a23c;
    }
    .study-plan-dashboard__hint--ok {
      color: #67c23a;
    }
    .study-plan-builder-wrap {
      max-width: 900px;
      margin: 0 auto;
      width: 100%;
      box-sizing: border-box;
      padding: 0 2px 4px;
    }
    .study-plan-pool-auto-hint {
      margin: 8px 0 10px;
      padding: 8px 12px;
      font-size: 13px;
      color: #67c23a;
      background: #f0f9eb;
      border: 1px solid #e1f3d8;
      border-radius: 6px;
    }
    .study-plan-pool-block {
      margin-bottom: 20px;
      &--elective {
        margin-bottom: 12px;
      }
    }
    .study-plan-dashboard__pool--inline {
      margin-bottom: 12px;
    }
    .study-plan-pool-row {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 12px 14px;
      margin-bottom: 8px;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      box-sizing: border-box;
    }
    .study-plan-pool-row__cb {
      flex-shrink: 0;
      margin-top: 2px;
    }
    .study-plan-pool-row__body {
      flex: 1;
      min-width: 0;
    }
    .study-plan-pool-row__title {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      font-size: 14px;
      line-height: 1.45;
      color: #303133;
      .main-title-icon {
        flex-shrink: 0;
        margin-top: 2px;
      }
    }
    .study-plan-pool-row__meta {
      margin-top: 8px;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
      font-size: 12px;
      color: #909399;
    }
    .study-plan-pool-row__author {
      margin-top: 4px;
      color: #909399;
      font-size: 12px;
      line-height: 1.35;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .study-plan-pool-row__section {
      margin-top: 6px;
      font-size: 12px;
      color: #909399;
      line-height: 1.4;
    }
    .study-plan-footer {
      position: static;
      flex-shrink: 0;
      background: #fff;
      border-top: 1px solid #e4e7ed;
      padding: 10px 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      .plan-stats {
        width: 100%;
        font-size: 13px;
        color: #606266;
        text-align: center;
        .divider {
          margin: 0 8px;
          color: #dcdfe6;
        }
      }
    }
    .study-plan-irreversible-hint {
      width: 100%;
      margin: 0;
      padding: 0 4px;
      font-size: 12px;
      line-height: 1.55;
      color: #e6a23c;
      text-align: center;
      box-sizing: border-box;
    }

    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__content {
      padding: 10px 0;
    }
    .el-tabs__item {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap,
    .el-collapse {
      border: none;
      color: #677897;
      font-weight: bold;
    }
  }
}

.plan-block-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    height: 100%;
    box-sizing: border-box;
  }
}
.plan-block-dialog__body {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 24px;
  box-sizing: border-box;
}
.plan-block-dialog__text {
  font-size: 18px;
  line-height: 1.65;
  color: #303133;
  max-width: 520px;
  margin: 0 0 28px;
}

.dual-quota-locked-progress {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
}
.dual-quota-locked-progress__row {
  line-height: 1.5;
}
.tab-pane-course .plan-stats--dual {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.plan-stats-dual-line {
  font-size: 13px;
  color: #606266;
}
.plan-stats-warn {
  color: #e6a23c;
  margin-left: 6px;
}
.plan-stats-ok {
  color: #67c23a;
  margin-left: 6px;
}
</style>
